import React from "react";

import ExploreSearchBar from "../../components/patient2/explore/ExploreSearchBar";
import ExploreFilters from "../../components/patient2/explore/ExploreFilters";
import ExploreDoctorList from "../../components/patient2/explore/ExploreDoctorList";
import ExploreOpenMapButton from "../../components/patient2/explore/ExploreOpenMapButton";

export default function ExploreScreen({
  searchTerm,
  onChangeSearch,
  onSubmitSearch,
  specialties = [],
  selectedSpecialty,
  onSelectSpecialty,
  onClearFilters,
  doctors = [],
  onOpenDoctorProfile,
  onBookDoctor,
  onOpenMap,
}) {
  return (
    <div className="p2-explore-root">
      {/* 1. Search bar */}
      <ExploreSearchBar
        value={searchTerm}
        onChange={onChangeSearch}
        onSubmit={onSubmitSearch}
        placeholder="Kërko mjek, klinikë ose simptomë…"
      />

      {/* 2. Filters */}
      <ExploreFilters
        specialties={specialties}
        selectedSpecialty={selectedSpecialty}
        onSelectSpecialty={onSelectSpecialty}
        onClear={onClearFilters}
      />

      {/* 3. Map button */}
      <ExploreOpenMapButton onOpen={onOpenMap} />

      {/* 4. Doctors */}
      <ExploreDoctorList
        doctors={doctors}
        onOpenProfile={onOpenDoctorProfile}
        onBook={onBookDoctor}
      />
    </div>
  );
}
